module.exports = __webpack_public_path__ + "static/img/ai_bg.2b076ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matrix/ai_bg.png
// module id = mmtH
// module chunks = 34